import {
  apiPutAlertsMarkSeenUuid,
  DefaultPatientAlertResponse,
  PermissionBit,
} from "../../../api";
import { location } from "../../../app/location";
import { AccessRules } from "../../../constants/roles";
import { DataModel } from "../../../models/data-model";

export type AlertsItem = DefaultPatientAlertResponse & {
  alert_owner?: { uuid: string };
  ownerUuid?: string;
  seenMark?: "Yes" | "No";
};

export class Alerts extends DataModel<AlertsItem> {
  constructor(
    data: AlertsItem[],
    permissions: PermissionBit[],
    userUUID: string,
  ) {
    super(data, permissions, userUUID);

    this.access = {
      editRules: { medical: AccessRules.none, monitoring: AccessRules.none },
      deleteRules: { medical: AccessRules.none, monitoring: AccessRules.none },
      historyRequiresMonitoring: false,
    };
  }

  init() {
    this.data = this.data.map((item) => {
      // TODO: alert_owner is not on DefaultPatientAlertResponse and ownerUuid is never read — likely dead code, verify and remove.
      const ownerUuid = item.alert_owner ? item.alert_owner.uuid : "N/A";
      const seenMark = item.alert_seen ? "Yes" : "No";
      return {
        ...item,
        ["ownerUuid"]: ownerUuid,
        ["seenMark"]: seenMark,
      };
    });
    super.init();
  }

  async markSeen(uuid: string) {
    await apiPutAlertsMarkSeenUuid({ path: { uuid: uuid } });
    location.reload();
  }
}
